/**
 * Front-end bootstrap
 */
import UserAgent from './helpers/userAgent';

UserAgent.setBodyClass();
